import * as qiniu from 'qiniu-js';
import {getUploadToken} from './service';
import {getHomeworkInfo} from '../lib/homework-info';

const homeworkInfo = getHomeworkInfo();
const courseId = Number(homeworkInfo.courseId);
const unitId = Number(homeworkInfo.unitId);
const lessonId = Number(homeworkInfo.lessonId);
const qiniuStroage = function (key, homeworkFile, progressObserver, cb, reject, bucket) {
    let token = '';
    try {
        const sessiontoken = sessionStorage.getItem('uptoken');
        if (bucket === 'sbdata' && sessiontoken) {
            token = sessiontoken;
        } else {
            token = getUploadToken(bucket);
        }
    } catch (err){
        reject(err);
    }

    if (token === '') {
        reject({err: 'token cannot be empty'});
        sa.track('token_error', {
            courseId: courseId,
            unitId: unitId,
            lessonId: lessonId,
            currentUrl: location.href,
            eventOrigin: 'qiniu'
        });
    }
    const putExtra = {
        fname: 'hetao.sb3',
        params: {},
        mimeType: ['application/zip'] // 文件类型指定，否则当文件大于4m分片上传时会传不成
    };
    const config = {
        useCdnDomain: true,
        region: null // 值为null时，自动分析上传域名区域 by cjr
    };
    const uploadToQiniuObserver = {
        next (res) {
            if (progressObserver) {
                progressObserver(parseInt(res.total.percent, 10));
            }
        },
        error (err) {
            reject({err: err});
            sa.track('upload_error', {
                courseId: courseId,
                unitId: unitId,
                lessonId: lessonId,
                currentUrl: location.href,
                eventOrigin: 'qiniu'
            });
        },
        complete (res) {
            cb(res.key);
        }
    };

    // 传入配置
    const observable = qiniu.upload(homeworkFile, key, token, putExtra, config);
    // 开始上传
    observable.subscribe(uploadToQiniuObserver);
};

export default qiniuStroage;
